var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExRetireOrgObject',{attrs:{"value":_vm.value,"OrgObjectType":"responsibility","name":_vm.responsibility,"htmlInfo":_vm.htmlInfo,"retireResponsibility":_vm.retireResponsibility},on:{"input":function($event){return _vm.$emit('input', $event)},"onAction":function($event){return _vm.$emit('onSave')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }